export enum TripDateCriteria {
  ALL       = 'ALL',
  CUSTOM    = 'CUSTOM'
}
